import { Button, Modal, } from "react-bootstrap";
import styles from "./shopHistoryPop.module.scss";
import moment from "moment";
import { showToast } from "../../../helper/common";

const ShopHistoryPop = ({ show, onHide, transaction }) => {

    const handledHide = () => {
        onHide(!show);
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(transaction.transactionHash);
        showToast('Transaction Hash copied!', "info");
    };

    return (
        <>
            <Modal
                show={show}
                onHide={handledHide}
                backdrop="true"
                centered
                className={`${styles.shopHistoryPop} bottomPop`}
                keyboard={false}
            >
                <div className="modalWrpper">

                    <Modal.Body>
                        <Button
                            onClick={handledHide}
                            variant="transparent"
                            className="border-0 p-0 position-absolute"
                            style={{ top: 15, right: 15 }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                                    fill="#506380"
                                />
                            </svg>
                        </Button>
                        <div className="text-center">
                            <div className="d-flex align-items-center justify-content-center gap-10">
                                <h2 className={`${styles.title} m-0 fw-bold`}>HISTORY DETAILS</h2>
                            </div>
                        </div>

                        <div className={`${styles.transactionDetails} text-white p-2 rounded shadow-sm`}>
                            <div className="mb-3">
                                <strong className={`${styles.labelSubtle}`}>ID:</strong>
                                <div className="fs-6">{transaction?.purchaseID || 'N/A'}</div>
                            </div>

                            <div className="mb-3">
                                <strong className={`${styles.labelSubtle}`}>Energy:</strong>
                                <div className="fs-6">{transaction?.energy || 'N/A'}</div>
                            </div>

                            <div className="mb-3">
                                <strong className={`${styles.labelSubtle}`}>Amount:</strong>
                                <div className="d-flex align-items-center fs-6">
                                    <span className="me-2">{transaction?.amount?.toFixed(4) || 0}</span>
                                    {transaction?.currencyIcon && (
                                        <img
                                            src={transaction.currencyIcon}
                                            alt="Currency Icon"
                                            className="img-fluid"
                                            style={{ height: 20, width: 20, objectFit: 'contain' }}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="mb-3">
                                <strong className={`${styles.labelSubtle}`}>Status:</strong>
                                <div
                                    className={`fs-6 fw-semibold ${transaction?.paymentStatus === 'success'
                                        ? 'text-success'
                                        : transaction?.paymentStatus === 'failed'
                                            ? 'text-danger'
                                            : 'text-warning'
                                        }`}
                                >
                                    {transaction?.paymentStatus
                                        ? transaction.paymentStatus.charAt(0).toUpperCase() + transaction.paymentStatus.slice(1)
                                        : 'Unknown'}
                                </div>
                            </div>

                            <div className="mb-3">
                                <strong className={`${styles.labelSubtle}`}>Time:</strong>
                                <div className="fs-6">
                                    {transaction?.transactionCompletedAt
                                        ? moment(transaction.transactionCompletedAt).format('DD.MM.YY HH:mm:ss')
                                        : 'N/A'}
                                </div>
                            </div>

                            <div className="mb-3">
                                <strong className={`${styles.labelSubtle}`}>Transaction Hash:</strong>
                                <div className="d-flex align-items-center fs-6">
                                    {(transaction?.network === "testnet" || transaction?.network === "mainnet") ? (
                                        <a
                                            href={`https://${transaction.network === "testnet" ? "testnet." : ""}tonviewer.com/transaction/${transaction?.transactionHash}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-break text-decoration-underline text-info"
                                            style={{ wordBreak: 'break-word' }}
                                        >
                                            {transaction?.transactionHash || 'N/A'}
                                        </a>
                                    ) : (
                                        'N/A'
                                    )}
                                </div>

                            </div>

                            <div className="text-center mt-3">
                                <Button
                                    onClick={handledHide}
                                    className="w-100 text-uppercase fw-bold commonBtn border-0 py-2"
                                    style={{ letterSpacing: '1px' }}
                                >
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        </>
    );
};

export default ShopHistoryPop;
